import { useEffect } from "react";

const SITE = "Meguiar's İzmit";
const DEFAULT_OG = "https://www.meguiarsizmit.com/og-cover.jpg";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets document title, meta description, OG/Twitter tags, canonical and JSON-LD schema.
 */
export default function Seo({ title, description, image, canonicalPath, jsonLd, noindex }) {
  useEffect(() => {
    const fullTitle = title ? (title.includes(SITE) ? title : `${title} | ${SITE}`) : SITE;
    document.title = fullTitle;

    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");

    const url = canonicalPath ? `${window.location.origin}${canonicalPath}` : window.location.href;
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", SITE);
    const ogImage = image ? (image.startsWith("http") ? image : `${window.location.origin}${image}`) : DEFAULT_OG;
    upsertMeta("property", "og:image", ogImage);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    // JSON-LD
    const existing = document.head.querySelectorAll('script[data-seo-jsonld="true"]');
    existing.forEach((n) => n.remove());
    if (jsonLd) {
      const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      blocks.forEach((block) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-jsonld", "true");
        s.text = JSON.stringify(block);
        document.head.appendChild(s);
      });
    }
  }, [title, description, image, canonicalPath, jsonLd, noindex]);

  return null;
}
